import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({ components: {} })
export default class ResourcesCountCard extends Vue {
  @Prop() public tenant?: string;
  @Prop({ default: false }) public plain?: boolean;
}
